import React, { useState } from "react";
import PurchaseIcon from "../../assets/icons/boomerang_element-01.svg2";
import RenewIcon from "../../assets/icons/calendar.svg2";
import { Button, Form } from "react-bootstrap";
import { usePurchaseSolutionMutation } from "../store/slices/settingsSlice";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { makeid } from "../helpers";

export default function SolutionPurchaseOptions({ solution }) {
  const [purchasing, setPurchasing] = useState(false);
  const [clientSolutionName, setClientSolutionName] = useState(
    solution?.Label || ""
  );
  const [clientSolutionReference, setClientSolutionReference] = useState(() =>
    makeid(8)
  );
  const [clientSolutionDescription, setClientSolutionDescription] = useState("");
  const [purchase] = usePurchaseSolutionMutation();
  const trimmedClientSolutionName = clientSolutionName.trim();
  const trimmedClientSolutionReference = clientSolutionReference.trim();
  const trimmedClientSolutionDescription = clientSolutionDescription.trim();

  return (
    <div className="bg-icon rounded-3 p-3">
      <div className="fw-bold text-center fs-4">
        <PurchaseIcon width={30} className="m-2" /> Purchase options:
        <hr className="text-secondary" />
      </div>
      <div className="d-flex align-items-center justify-content-evenly">
        <div>
          <div className="fs-5 fw-bold">Template price:</div>
          <div>
            <span className="fw-bold fs-1 text-blue">£25.99</span>
            <span className="fw-bold">+VAT</span>
          </div>
          <div>
            <RenewIcon width={20} className="me-2" />
            <span>Renews at £25.99 each month</span>
          </div>
        </div>
        <div>
          <div className="fw-bold fs-5 mb-2">Billing freuqency:</div>

          <select
            aria-label="Default select example"
            className="border-0 p-2 py-1 rounded-3 fw-bold mx-3"
          >
            <option>MONTLY</option>
            <option value="1">WEEKLY</option>
            <option value="2">YEARLY</option>
            <option value="3">FORTNIGHTLY</option>
          </select>
        </div>
      </div>
      <hr className="my-2" />
      <Form.Group className="mt-3">
        <Form.Label className="fw-bold" htmlFor="client-solution-name">
          Give a custom name for this solution instance
        </Form.Label>
        <Form.Control
          id="client-solution-name"
          type="text"
          value={clientSolutionName}
          onChange={(event) => setClientSolutionName(event.target.value)}
          maxLength={255}
          required
        />
        <Form.Text className="text-muted">
          Use a name that helps you identify this purchased solution.
        </Form.Text>
      </Form.Group>
      <Form.Group className="mt-3">
        <Form.Label className="fw-bold" htmlFor="client-solution-reference">
          Reference
        </Form.Label>
        <Form.Control
          id="client-solution-reference"
          type="text"
          value={clientSolutionReference}
          onChange={(event) => setClientSolutionReference(event.target.value)}
          maxLength={255}
        />
        <Form.Text className="text-muted">
          Optionally add a reference for this solution instance.
        </Form.Text>
      </Form.Group>
      <Form.Group className="mt-3">
        <Form.Label className="fw-bold" htmlFor="client-solution-description">
          Description
        </Form.Label>
        <Form.Control
          as="textarea"
          id="client-solution-description"
          rows={3}
          value={clientSolutionDescription}
          onChange={(event) => setClientSolutionDescription(event.target.value)}
        />
        <Form.Text className="text-muted">
          Optionally describe this solution instance.
        </Form.Text>
      </Form.Group>
      <div className="text-center">
        <Button
          className="bg-black rounded-pill mt-4 w-50 py-3 fw-bold"
          onClick={async () => {
            if (!trimmedClientSolutionName) {
              return;
            }

            setPurchasing(true);
            await purchase({
              SolutionUuid: solution.Uuid,
              SolutionName: trimmedClientSolutionName,
              Reference: trimmedClientSolutionReference,
              Description: trimmedClientSolutionDescription,
            }).then((response) => {
              setTimeout(() => {
                setPurchasing(false);
                // navigate(`/library/solutions/${solution.Uuid}/details`);
              }, 700);
              if ("data" in response === false) {
                toast.error("Error purchasing solution");
                return;
              }
              toast.success("Solution purchased successfully");
            });
          }}
          disabled={purchasing || !trimmedClientSolutionName}
        >
          <PurchaseIcon width={25} className=" purple rounded-circle p-1" />
          Purchase Solution
          {purchasing ? (
            <FontAwesomeIcon icon={faSpinner} className="ms-2" spin />
          ) : (
            ""
          )}
        </Button>
        <br />
        <span className="small">
          You pay £25.99 today. Your next billing day will be on 30/ 09/2026.
        </span>
      </div>
    </div>
  );
}
